export default "__VITE_ASSET__icknyx7X__"